<template>
  <v-row>
    <v-col cols="12">
      <v-tabs
        background-color="kbWhite"
        centered
        color="kbBlue"
        v-model="tab"
      >
        <v-tab
          v-for="(item, index) in items"
          :key="index"
        >
         {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items class="kbWhite" v-model="tab">
        <v-tab-item>
          <UserConfigurationProfile />
        </v-tab-item>

        <v-tab-item>
          <GraphicAspect />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import GraphicAspect from '@/pages/App/UserConfiguration/GraphicAspect'
import UserConfigurationProfile from '@/pages/App/UserConfiguration/UserConfigurationProfile'
export default {
  components: { GraphicAspect, UserConfigurationProfile },
  computed: {
    items () {
      return [
        { name: this.$t('sidebar.userConfiguration') },
        { name: this.$t('sidebar.graphicAspect') }
      ]
    }
  },
  data () {
    return {
      tab: 0
    }
  }
}
</script>
